import React from 'react';
import { globals } from 'common-ui';
import type { LineItem } from 'tsconfig/types';

type TaxMessageProps = {
  selectedItem: LineItem[] | undefined;
};

const TaxMessage: React.FC<TaxMessageProps> = ({ selectedItem }) => {
  let message = 'Applicable tax, shipping and any additional discounts will display at checkout.';

  if (globals.country === 'au') {
    message = 'All prices are inclusive of GST. Any additional discounts will be displayed at checkout.';
  } else if (globals.country === 'uk') {
    if (globals.brandId === 'amx') {
      message = '';
    } else {
      message = 'Any additional discounts will display at checkout.';
    }
  }

  const isPresellItem = selectedItem?.[0]?.itemClassifications?.includes('PRESELL_ITEM');

  return (
    <div className="tax">
      {globals.country === 'au' && isPresellItem && (
        <p className="tax-info">
          The price shown is the total for this wine. You will only be charged the reservation payment today.
        </p>
      )}
      {message && <p className="tax-info">{message}</p>}
    </div>
  );
};

export default TaxMessage;
